import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const FileAttachmentContext = /*#__PURE__*/createContext(undefined);
export const FileAttachmentProvider = ({
  closeButtonStyleOverrides,
  children
}) => {
  const memoizedValue = useMemo(() => {
    return {
      closeButtonStyleOverrides
    };
  }, [closeButtonStyleOverrides]);
  return /*#__PURE__*/_jsx(FileAttachmentContext.Provider, {
    value: memoizedValue,
    children: children
  });
};

/**
 * Provides the context for the `FileAttachment` component.
 * Note: The context is only available when the `FileAttachment` component is rendered as an ancestor.
 * @returns FileAttachmentContext - The context for the `FileAttachment` component.
 * @returns FileAttachmentContext.closeButtonStyleOverrides - Style overrides to be applied to the `CloseButton` component.
 */
export const useFileAttachmentContext = () => {
  const fileAttachmentContext = useContext(FileAttachmentContext);
  return fileAttachmentContext;
};